import { createContext, useContext } from 'react';
import { enableStaticRendering } from 'mobx-react-lite';
import CartStore from '@features/cart/mobx/stores/CartStore';
enableStaticRendering(typeof window === 'undefined');
let store;
const initializeStore = () => {
  const newStore = store ?? new CartStore();
  if (typeof window === 'undefined') return newStore;
  if (!store) store = newStore;
  return newStore;
};
const CartStoreContext = createContext<CartStore>(initializeStore());
const useCartStore = () => useContext(CartStoreContext);
export { CartStore, useCartStore };